import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Latin from "./ArchitectsDaughter-Regular-KtkxAKiDZI_td1Lkx62xHZHDtgO_Y-bvTYdg4-7jA-Wztg.woff2";

export const ArchitectsDaughterFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: Latin,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
    },
  },
];
